import { useToggle } from '@tonic-one/react-hooks';
import {
  Alert,
  AlertCloseButton,
  Collapse,
  Flex,
  Link,
  Text,
} from '@tonic-one/react';
import { Trans } from 'react-i18next';
import { CAS_DOC_LINK, getCasOLHLink } from '@Utils/casDocLink';
import { ProvisionApi } from '@Apis';
import { App } from '@Types/app';
import { useOrgStore } from '@Models/useOrgModel';
import { useEffect, useState } from 'react';
import i18next from 'i18next';
import { SpodMigrationModal } from 'src/pages/Administrator/ServiceAccount/SpodMigrationModal';
import { usePermissionStore } from '@Models/usePermissionModel';
import { PermissionNameEnum } from '@Types/permissions';
const AlertBanner = ({ children }: any) => {
  const [isOpen, toggleIsOpen] = useToggle(true);
  const onClose = () => toggleIsOpen(false);

  return (
    <Collapse in={isOpen} unmountOnExit>
      <Alert variant="outline" severity="info" onClose={onClose} mt={8}>
        <Flex alignItems="center" justifyContent="space-between" mr="10x">
          <Text>{children}</Text>
        </Flex>
        <AlertCloseButton
          top={3}
          right={7}
          position="absolute"
          data-test="alert-close-button"
        />
      </Alert>
    </Collapse>
  );
};

const SpodMigrationBanner = () => {
  const { orgId } = useOrgStore();
  const [isSpNeedMigration, setIsSpNeedMigration] = useState(false);
  const [isOdNeedMigration, setIsOdNeedMigration] = useState(false);
  const [isOpen, toggleOpen] = useToggle(false);
  const { widthEditablePermission } = usePermissionStore();

  useEffect(() => {
    (async () => {
      const spNeedMigrationRes = await ProvisionApi.getMigrationRequirement(
        orgId,
        App.SharePoint
      );
      setIsSpNeedMigration(spNeedMigrationRes.data);
      const odNeedMigrationRes = await ProvisionApi.getMigrationRequirement(
        orgId,
        App.OneDrive
      );
      setIsOdNeedMigration(odNeedMigrationRes.data);
    })();
  }, [orgId]);

  return (
    <>
      {isOpen && <SpodMigrationModal orgId={orgId} onClose={toggleOpen} />}
      {isSpNeedMigration && (
        <AlertBanner>
          <Trans
            i18nKey="common.office365Credentials.spMigrateLink"
            values={{}}
          >
            placeholder
            <Link
              href={getCasOLHLink(
                CAS_DOC_LINK.administrator.migration.spMigrate,
                i18next.language
              )}
              target="_blank"
            ></Link>
            <Link
              target="_blank"
              onClick={toggleOpen}
              disabled={
                !widthEditablePermission(PermissionNameEnum.administrator)
              }
            ></Link>
          </Trans>
        </AlertBanner>
      )}
      {isOdNeedMigration && (
        <AlertBanner>
          <Trans
            i18nKey="common.office365_credentials.odMigrateLink"
            values={{}}
          >
            placeholder
            <Link
              href={getCasOLHLink(
                CAS_DOC_LINK.administrator.migration.odMigrate,
                i18next.language
              )}
              target="_blank"
            ></Link>
            <Link
              onClick={toggleOpen}
              target="_blank"
              disabled={
                !widthEditablePermission(PermissionNameEnum.administrator)
              }
            ></Link>
          </Trans>
        </AlertBanner>
      )}
    </>
  );
};

export default SpodMigrationBanner;
